
const digest = 'd4d0756748f663a100fc96a193be1ea40b94bb3e165a853f38947de379624460';
const classes = {"wrapper":"_wrapper_plgt7_1","noItemsFound":"_noItemsFound_plgt7_9"};
const css = `._wrapper_plgt7_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
}

._noItemsFound_plgt7_9 {
  padding: 6px 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  